import {
  Box,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CloseIcon from '@material-ui/icons/Close';

type DialogHeaderProps = {
  title?: string | React.ReactNode;
  description?: string;
  onClose?: () => void;
  onBack?: () => void;
};

const useStyles = makeStyles(({ palette, spacing }) => ({
  root: {
    margin: 0,
    marginRight: spacing(5),
    padding: spacing(2, 3, 0),
  },
  closeButton: {
    color: palette.text.disabled,
    position: 'absolute',
    right: spacing(1),
    top: spacing(1),
  },
}));

export default function DialogHeader(props: DialogHeaderProps) {
  const { title, description, onClose, onBack } = props;
  const classes = useStyles();

  return (
    <DialogTitle disableTypography className={classes.root}>
      <Box display="flex" alignItems="center">
        {onBack ? (
          <IconButton
            size="small"
            aria-label="go back"
            edge="start"
            onClick={onBack}
          >
            <ArrowBackIcon />
          </IconButton>
        ) : null}

        <Box pl={onBack ? 3 : 0} flexGrow={1} overflow="hidden">
          <Typography noWrap variant="body1" style={{ fontWeight: 500 }}>
            {title}
          </Typography>
        </Box>
      </Box>

      {onClose ? (
        <IconButton
          size="small"
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}

      <DialogContentText variant="caption">{description}</DialogContentText>
    </DialogTitle>
  );
}
